
import { useEffect, useState } from "react";
import styled from "styled-components";
import { SubcontractorDataAndAddressAdd } from "./components/forms/address-and-data-subcontractor";
import { WarehouseDataAndAddressAdd } from "./components/forms/address-and-data-warehouse";

import { SubcontractorSummaryInfo } from "./components/summary-info";
import { useNavigate } from "react-router-dom";
import { urlOperator } from "../../../utils/url";
import { theme } from "../../../helpers/theme";
import { StorageClass } from "../../../services/warehouses/warehouse-add/types";
import { addSubcontractorToWarehouse } from "../../../services/subcontractor/ass-subcontractor-to-warehouse";
import { useMutation } from "@tanstack/react-query";
import { SuccessMessage } from "../operator-subcontractors-detail-edite/components/forms-wraper/helpers/success-message";
import { DataSaved } from "./components/data-saved";
import { Box } from "@mui/system";
import { Step, StepLabel, Stepper } from "@mui/material";



interface OperatorSubcontractorsAddProps {

}

export const successMessageContent: string[] = [
    "Adres podwykonawcy został pomyślnie zapisany",
    "Adres podwykonawcy został zmieniony",
    "Pomyślnie zapisano dane podwykonawcy",
    "Pomyślnie zmieniono dane podwykonawcy",
    "Adres magazynu został pomyślnie zapisany",
    "Adres magazynu został zmieniony",
    "Pomyślnie zapisano dane magazynu",
    "Pomyślnie zmieniono dane magazynu",
    "Pomyślnie połączono podwykonawcę z magazynem",
]

export type SubcontractorTestValue = {
    nazwa_wykonawcy: string,
    nip: string,
    telefon: string,
    email: string,
    kod_pocztowy: string,
    miejscowosc_poczty: string,
    miejscowosc: string,
    ulica: string,
    numer_budynku: string,
    numer_lokalu: string,
    wojewodztwo: string,
    kraj: string,
};
export type WarehouseTestValue = {
    kod_magazynu: string,
    opis: string,
    powierzchnia_procentowa: number,
    klasa_magazynu: StorageClass,
    medyczny: boolean,

    adres_uslugi: string,
    login: string,
    haslo: string,

    kod_pocztowy: string,
    miejscowosc_poczty: string,
    miejscowosc: string,
    ulica: string,
    numer_budynku: string,
    numer_lokalu: string,
    wojewodztwo: string,
    kraj: string,
}

export type SubcontractorAdAddressTestValue = {
    kod_pocztowy: string,
    miejscowosc_poczty: string,
    miejscowosc: string,
    ulica: string,
    numer_budynku: string,
    numer_lokalu: string,
    wojewodztwo: string,
    kraj: string,
};
export type WarehouseAdAddressTestValue = {
    kod_pocztowy: string,
    miejscowosc_poczty: string,
    miejscowosc: string,
    ulica: string,
    numer_budynku: string,
    numer_lokalu: string,
    wojewodztwo: string,
    kraj: string,
};
export type SubcontractorAddDataTestValue = {
    nazwa_wykonawcy: string,
    nip: string,
    telefon: string,
    email: string,
    //adres_id: string,
};
export type WarehouseAddDataTestValue = {
    kod_magazynu: string,
    opis: string,
    powierzchnia_procentowa: number,
    klasa_magazynu: StorageClass,
    medyczny: boolean,

    adres_uslugi: string,
    login: string,
    haslo: string,

};
export interface SubcontractorAddTestValue {
    address: SubcontractorAdAddressTestValue,
    data: SubcontractorAddDataTestValue,
    warehouse: WarehouseAddDataTestValue,
    addressWarehouse: WarehouseAdAddressTestValue,
}

export const OperatorSubcontractorsAdd = ({

}: OperatorSubcontractorsAddProps) => {
    let navigate = useNavigate();

    const steps = [
        'DANE PODWYKONAWCY',
        'DANE MAGAZYNU',
        'PODSUMOWANIE',
    ];
    const [activeStep, setActiveStep] = useState(0);
    const [isNextVisible, setIsNextVisible] = useState(true);
    const [isBackVisible, setIsBackVisible] = useState(true);

    const [addressID, setAddressID] = useState('no');
    const [warehouseAddressID, setWarehouseAddressID] = useState('no');
    const [subcontractorID, setSubcontractorID] = useState('no');
    const [warehouseID, setwarehouseID] = useState('no');

    const [actualInitialSubcontractorAddValue, setActualInitialSubcontractorAddValue] = useState({
        nazwa_wykonawcy: "",
        nip: "",
        telefon: "",
        email: "",

        kod_pocztowy: "",
        miejscowosc_poczty: "",
        miejscowosc: "",
        ulica: "",
        numer_budynku: "",
        numer_lokalu: "",
        wojewodztwo: "",
        kraj: "Polska",
    });

    const [actualInitialWarehouseAddValues, setActualInitialWarehouseAddValues] = useState({
        kod_magazynu: "",
        opis: "",
        powierzchnia_procentowa: 0,
        klasa_magazynu: 0,
        medyczny: false,

        adres_uslugi: "",
        login: "",
        haslo: "",

        kod_pocztowy: "",
        miejscowosc_poczty: "",
        miejscowosc: "",
        ulica: "",
        numer_budynku: "",
        numer_lokalu: "",
        wojewodztwo: "",
        kraj: "Polska",
    });

    const [backToSummary, setBackToSummary] = useState(false);
    const [warehouseSubcontractorConnection, setWarehouseSubcontractorConnection] = useState(false);


    const handleReset = () => {
        setActualInitialWarehouseAddValues({
            kod_magazynu: "",
            opis: "",
            powierzchnia_procentowa: 0,
            klasa_magazynu: 0,
            medyczny: false,

            adres_uslugi: "",
            login: "",
            haslo: "",

            kod_pocztowy: "",
            miejscowosc_poczty: "",
            miejscowosc: "",
            ulica: "",
            numer_budynku: "",
            numer_lokalu: "",
            wojewodztwo: "",
            kraj: "Polska",
        });
        setActualInitialSubcontractorAddValue({
            nazwa_wykonawcy: "",
            nip: "",
            telefon: "",
            email: "",

            kod_pocztowy: "",
            miejscowosc_poczty: "",
            miejscowosc: "",
            ulica: "",
            numer_budynku: "",
            numer_lokalu: "",
            wojewodztwo: "",
            kraj: "Polska",
        });

        setWarehouseSubcontractorConnection(false); //todo
        setActiveStep(0);
        setIsNextVisible(false);
        setIsBackVisible(false);
        setBackToSummary(false);

        setAddressID('no');
        setSubcontractorID('no');
        setWarehouseAddressID('no');
        setwarehouseID('no');
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleNext = () => {
        activeStep === steps.length
            ? (

                addSubcontractorToWarehouseMutation.mutate({
                    magazyn_id: warehouseID,
                    wykonawca_id: subcontractorID
                })
            )

            : (
                (activeStep === 4
                    ? navigate(urlOperator.subcontractors)
                    : setActiveStep((prevActiveStep) => prevActiveStep + 1)
                )
            )


    }

    const forms: React.ReactNode[] = [
        <SubcontractorDataAndAddressAdd
            actualInitialSubcontractorAddValue={actualInitialSubcontractorAddValue}
            addressID={addressID}
            subcontractorID={subcontractorID}
            warehouseSubcontractorConnection={warehouseSubcontractorConnection}
            setActualInitialSubcontractorAddValue={setActualInitialSubcontractorAddValue}
            setIsNextVisible={setIsNextVisible}
            setIsBackVisible={setIsBackVisible}
            setSubcontractorID={setSubcontractorID}
            setAddressID={setAddressID}
            setActiveStep={setActiveStep}
            setBackToSummary={setBackToSummary}
            backToSummary={backToSummary}
        />,
        <WarehouseDataAndAddressAdd
            actualInitialWarehouseAddValues={actualInitialWarehouseAddValues}
            warehouseSubcontractorConnection={warehouseSubcontractorConnection}
            setActualInitialWarehouseAddValues={setActualInitialWarehouseAddValues}
            setIsNextVisible={setIsNextVisible}
            setIsBackVisible={setIsBackVisible}
            setWarehouseAddressID={setWarehouseAddressID}
            setwarehouseID={setwarehouseID}
            setActiveStep={setActiveStep}
            warehouseAddressID={warehouseAddressID}
            warehouseID={warehouseID}
            setBackToSummary={setBackToSummary}
            backToSummary={backToSummary}
        />,
        <SubcontractorSummaryInfo
            actualInitialSubcontractorAddValue={actualInitialSubcontractorAddValue}
            actualInitialWarehouseAddValues={actualInitialWarehouseAddValues}
            addressID={addressID}
            warehouseAddressID={warehouseAddressID}
            subcontractorID={subcontractorID}
            warehouseID={warehouseID}
            warehouseSubcontractorConnection={warehouseSubcontractorConnection}
            setActiveStep={setActiveStep}
            activeStep={activeStep}
            setBackToSummary={setBackToSummary}
            setAddressID={setAddressID}
            setWarehouseAddressID={setWarehouseAddressID}
            setSubcontractorID={setSubcontractorID}
            setwarehouseID={setwarehouseID}
            setWarehouseSubcontractorConnection={setWarehouseSubcontractorConnection}
        />
    ];



    useEffect(() => {
    }, [isBackVisible, isNextVisible, addressID, warehouseAddressID, subcontractorID, warehouseID]);

    useEffect(() => {

    }, []);

    useEffect(() => {

    }, [actualInitialWarehouseAddValues]);

    const [successMessage, setsuccessMessage] = useState(successMessageContent[8]);
    const [openSuccessInfo, setOpenSuccessInfo] = useState(false);


    const addSubcontractorToWarehouseMutation = useMutation(addSubcontractorToWarehouse, {
        onSuccess: (res) => {
            setsuccessMessage(successMessageContent[8]);
            setOpenSuccessInfo(true);

            setWarehouseSubcontractorConnection(true);
            setIsBackVisible(false);
        },
    });


    useEffect(() => {

    }, [warehouseSubcontractorConnection]);



    return (

        <PageContent>
            <Box sx={{ width: '100%', paddingBottom: "60px" }}>
                {activeStep === steps.length
                    ? <></>
                    : <Stepper
                        sx={{
                            margin: "auto",
                            marginBottom: "30px",
                            '.Stepper-dot': { backgroundColor: '#CCCCCC' },
                            '.Stepper-dotActive': { backgroundColor: '#666666' },
                        }}
                        activeStep={activeStep}
                        alternativeLabel={true}
                    >
                        {steps.map((label) => {
                            const stepProps: { completed?: boolean } = {};
                            const labelProps: {
                                optional?: React.ReactNode;
                            } = {};
                            return (
                                <Step
                                    key={label}
                                    {...stepProps}
                                    sx={{

                                        '& .MuiStepLabel-root .Mui-completed': {
                                            color: `${theme.colors.black_primaryText}`
                                        },
                                        '& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel':
                                        {
                                            color: `${theme.colors.gray01_secondaryText}`,
                                            fontSize: '14px',

                                        },
                                        '& .MuiStepLabel-root .Mui-active': {
                                            color: `${theme.colors.blue01_active}`
                                        },
                                        '& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel':
                                        {
                                            color: `${theme.colors.blue01_active}`
                                        },
                                        '& .MuiStepLabel-root .Mui-active .MuiStepIcon-text': {
                                            fill: `${theme.colors.white}`
                                        },
                                    }}>
                                    <StepLabel {...labelProps}
                                        sx={{
                                            fontSize: '12px'
                                        }}
                                    >
                                        <IsLabelVisible>
                                            {label}
                                        </IsLabelVisible>
                                    </StepLabel>
                                </Step>
                            );
                        })}
                    </Stepper>}


                {activeStep === steps.length

                    ?
                    <>

                        <DataSaved
                            warehouseSubcontractorConnection={warehouseSubcontractorConnection}
                            handleReset={handleReset}

                        />
                        < SuccessMessage
                            message={successMessage}
                            setOpenSuccessInfo={setOpenSuccessInfo}
                            openSuccessInfo={openSuccessInfo}
                        />
                    </>
                    :
                    <>{forms[activeStep]}
                    </>
                }
            </Box>
        </PageContent>
    )
}


const PageContent = styled.div`
display: flex;
justify-content: center;
align-items: stretch;
@media(min-width:1025px){
    margin-left:310px;
    margin-right:20px;
}`;

const IsLabelVisible = styled.div`
@media(max-width:400px){
    display:none;
}
`;
const Navigation = styled.div<{
    isDisable: boolean;

}>`
color: ${(props: any) => (props.isDisable
        ? `${theme.colors.blue01_active} `
        : "#00000061")};
`

